(function($){

    $('[data-orbit]').on('resizeme.zf.trigger', function(){
        Foundation.reInit('orbit');
    });

    $(".images-lightbox-card-figure").on("click", function() {
        // https://stackoverflow.com/questions/38534315/foundation-6-orbit-change-slide-programatically
        var figIndex = $(this).data("image-source");
        if (figIndex) {
            var $figLightbox = $("[data-image-lightbox=" + figIndex + "]");
            if ($figLightbox.length) {
                var $slide = $figLightbox.parent(".orbit-slide");
                if ($slide.length) {
                    var slideNr = $slide.data("slide");
                    if ($.isNumeric(slideNr)) {
                        $(".orbit").foundation("changeSlide", true, $("[data-slide=" + slideNr + "]"), slideNr);
                    }
                }
            }
        }
    });

}(jQuery));
